import packageConfig from '../../../package.json'

const baseUrl = process.env.NODE_ENV === 'development' ? '/imgUrl' : `${process.env.VUE_APP_RESOURCE_URL}`;
const imgUrl = `${baseUrl}/ct_hisSystem/images`;
const imgArr = {
    error404: `${imgUrl}/404.jpg?v=${packageConfig.version}`,
    account: `${imgUrl}/account.jpg?v=${packageConfig.version}`,
    alipay: `${imgUrl}/alipay.png?v=${packageConfig.version}`,
    bookIcon: `${imgUrl}/book-icon.png?v=${packageConfig.version}`,
    callNum: `${imgUrl}/callNum.png?v=${packageConfig.version}`,
    cash: `${imgUrl}/cash.png?v=${packageConfig.version}`,
    codeScan: `${imgUrl}/codeScan.jpg?v=${packageConfig.version}`,
    comboIcon: `${imgUrl}/combo-icon.png?v=${packageConfig.version}`,
    crad: `${imgUrl}/crad.png?v=${packageConfig.version}`,
    dangan: `${imgUrl}/dangan.png?v=${packageConfig.version}`,
    dataBoard: `${imgUrl}/dataBoard.png?v=${packageConfig.version}`,
    dataBoardNew: `${imgUrl}/dataBoardNew.png?v=${packageConfig.version}`,
    delIcon: `${imgUrl}/del-icon.png?v=${packageConfig.version}`,
    deleteIcon: `${imgUrl}/delete-icon.png?v=${packageConfig.version}`,
    doctor: `${imgUrl}/doctor.jpg?v=${packageConfig.version}`,
    dragIcon: `${imgUrl}/drag-icon.jpg?v=${packageConfig.version}`,
    drugIcon: `${imgUrl}/drugIcon.png?v=${packageConfig.version}`,
    explainIcon: `${imgUrl}/explain-icon.png?v=${packageConfig.version}`,
    file: `${imgUrl}/file.png?v=${packageConfig.version}`,
    girlIcon: `${imgUrl}/girl-icon.png?v=${packageConfig.version}`,
    haomuch: `${imgUrl}/haomuch.png?v=${packageConfig.version}`,
    howmuch: `${imgUrl}/howmuch.png?v=${packageConfig.version}`,
    kong: `${imgUrl}/kong.png?v=${packageConfig.version}`,
    login_bg: `${imgUrl}/login_bg.jpg?v=${packageConfig.version}`,
    logo: `${imgUrl}/logo.png?v=${packageConfig.version}`,
    logo1: `${imgUrl}/logo1.png?v=${packageConfig.version}`,
    manIcon: `${imgUrl}/man-icon.png?v=${packageConfig.version}`,
    note: `${imgUrl}/note.png?v=${packageConfig.version}`,
    phyIcon: `${imgUrl}/phyIcon.png?v=${packageConfig.version}`,
    plus: `${imgUrl}/plus.png?v=${packageConfig.version}`,
    pring: `${imgUrl}/pring.png?v=${packageConfig.version}`,
    printIcon: `${imgUrl}/print-icon.png?v=${packageConfig.version}`,
    refund: `${imgUrl}/refund.png?v=${packageConfig.version}`,
    scan: `${imgUrl}/scan.png?v=${packageConfig.version}`,
    shortcutKey: `${imgUrl}/shortcutKey.png?v=${packageConfig.version}`,
    Slice: `${imgUrl}/Slice.png?v=${packageConfig.version}`,
    static: `${imgUrl}/static.png?v=${packageConfig.version}`,
    statusBg1: `${imgUrl}/statusBg1.png?v=${packageConfig.version}`,
    statusBg2: `${imgUrl}/statusBg2.png?v=${packageConfig.version}`,
    statusBg3: `${imgUrl}/statusBg3.png?v=${packageConfig.version}`,
    voice_l: `${imgUrl}/voice-l.png?v=${packageConfig.version}`,
    voice_play_l: `${imgUrl}/voice-play-l.gif?v=${packageConfig.version}`,
    voice_play_r: `${imgUrl}/voice-play-r.gif?v=${packageConfig.version}`,
    voice_r: `${imgUrl}/voice-r.png?v=${packageConfig.version}`,
    wechat: `${imgUrl}/wechat.png?v=${packageConfig.version}`,
    weixin: `${imgUrl}/weixin.jpg?v=${packageConfig.version}`,
    changeType: `${imgUrl}/changeType.png?v=${packageConfig.version}`,
    chineseMedicineIcon: `${imgUrl}/chineseMedicine-icon.jpg?v=${packageConfig.version}`,
    formulaIcon: `${imgUrl}/formula-icon.png?v=${packageConfig.version}`,
    star: `${imgUrl}/star.png?v=${packageConfig.version}`,
    uploadImg: `${imgUrl}/upload-img.png?v=${packageConfig.version}`,
    kaiPiaoZhong: `${imgUrl}/kaiPiaoZhong.png?v=${packageConfig.version}`,
    yiZuoFei: `${imgUrl}/yiZuoFei.png?v=${packageConfig.version}`,
    yiHongChong: `${imgUrl}/yiHongChong.png?v=${packageConfig.version}`,
    yiKaiPiao: `${imgUrl}/yiKaiPiao.png?v=${packageConfig.version}`,
    greenMark: `${imgUrl}/greenMark.png?v=${packageConfig.version}`,
    grayMark: `${imgUrl}/grayMark.png?v=${packageConfig.version}`,
    acupointIcon: `${imgUrl}/acupoint-icon.png?v=${packageConfig.version}`,
    executeIcon: `${imgUrl}/executeIcon.png?v=${packageConfig.version}`,
    formulaNoData: `${imgUrl}/formula-no-data.png?v=${packageConfig.version}`,
    pickIcon: `${imgUrl}/pickIcon.png?v=${packageConfig.version}`,
    companyIcon1: `${imgUrl}/companyIcon1.png?v=${packageConfig.version}`,
    companyIcon2: `${imgUrl}/companyIcon2.png?v=${packageConfig.version}`,
    companyIcon3: `${imgUrl}/companyIcon3.png?v=${packageConfig.version}`,
    couponScan: `${imgUrl}/couponScan.png?v=${packageConfig.version}`,
    couponPhone: `${imgUrl}/couponPhone.png?v=${packageConfig.version}`,
    noCoupon: `${imgUrl}/noCoupon.png?v=${packageConfig.version}`,
    traceCodesError: `${imgUrl}/traceCodes-error.png?v=${packageConfig.version}`,
    traceCodesSuccess: `${imgUrl}/traceCodes-Success.png?v=${packageConfig.version}`,
    a1: `${imgUrl}/a1.png?v=${packageConfig.version}`,
    a2: `${imgUrl}/a2.json?v=${packageConfig.version}`,
    a3: `${imgUrl}/a3.png?v=${packageConfig.version}`,
    a4: `${imgUrl}/a4.png?v=${packageConfig.version}`,
}
export {
    imgArr
}